import { useState } from 'react';

const MyPortfolio = () => {
  const [activeTab, setActiveTab] = useState('p-one');

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  return (
    <>
      <section className='my-portfolio-container' id='portfolio'>
        <div className='portfolio-container ' data-aos='fade-up'>
          <div className='portfolio-library ' data-aos='fade-right'>
            <div className='p-warpper'>
              <input
                className='p-radio'
                id='p-one'
                name='p-group'
                type='radio'
                checked={activeTab === 'p-one'}
                onChange={() => handleTabClick('p-one')}
              />
              <input
                className='p-radio'
                id='p-two'
                name='p-group'
                type='radio'
                checked={activeTab === 'p-two'}
                onChange={() => handleTabClick('p-two')}
              />
              <input
                className='p-radio'
                id='p-three'
                name='p-group'
                type='radio'
                checked={activeTab === 'p-three'}
                onChange={() => handleTabClick('p-three')}
              />

              <div className='p-tabs'>
                <label
                  data-aos='flip-up'
                  className='p-tab hover-underline-animation'
                  id='p-one-tab'
                  htmlFor='p-one'
                >
                  Tab 1
                </label>
                <label
                  data-aos='flip-up'
                  className='p-tab hover-underline-animation'
                  id='p-two-tab'
                  htmlFor='p-two'
                >
                  Tab 2
                </label>
                <label
                  data-aos='flip-up'
                  className='p-tab hover-underline-animation'
                  id='p-three-tab'
                  htmlFor='p-three'
                >
                  Tab 3
                </label>
              </div>

              <div className='p-panels'>
                <div
                  className='p-panel'
                  id='p-one-panel'
                  style={{
                    display: activeTab === 'p-one' ? 'block' : 'none',
                  }}
                >
                  <section className='portfolio-section-grid'>
                    <div className='portfolio-card' data-aos='fade-right'>
                      <div>
                        {' '}
                        <img src='assets/sociopedia.png' alt='sociopedia' />
                        <div class='card-content'>
                          <h2>FaceBook Clone ( CRUD | FullStack)</h2>

                          <p>
                            Please Create an Account to access all features.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br /> Dark and Light Mode, Authentication,
                            Authorization, Profile Management, Like & Comment,
                            Image Upload, Friends Management. <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js, Redux Toolkit, Node.js, Express.js,
                            MongoDB, Multer, JWT Token.
                          </p>

                          <a
                            target='_blank'
                            href='https://sociopedia-front-end.onrender.com/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='portfolio-card' data-aos='fade-left'>
                      <div>
                        {' '}
                        <img src='assets/kaamseva.png' alt='kaamseva' />
                        <div class='card-content'>
                          <h2>
                            Client #1 (
                            <span style={{ textTransform: 'lowercase' }}>
                              Client requested a dashboard
                            </span>{' '}
                            )
                          </h2>

                          <p>
                            A comprehensive online platform designed to help
                            individuals discover their ideal career paths and
                            find fulfilling employment.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Dark and Light Mode, Authentication, Authorization,
                            Profile Management, Add User, Add Admin, Add
                            Employees
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js, Redux Toolkit, Node.js, Express.js,
                            MongoDB, JWT Token, NivoCharts.
                          </p>

                          <a
                            target='_blank'
                            href='https://kaamseva-frontend.onrender.com/login/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='portfolio-card' data-aos='fade-right'>
                      <div>
                        {' '}
                        <img src='assets/dalle-e.png' alt='dalle' />
                        <div class='card-content'>
                          <h2>Dalle-E Clone(Full Stack)</h2>

                          <p>
                            Community showcase enabled, insert an image to
                            transform it with a prompt you like.(Although the my
                            api credit ran out)
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Community Showcase, Like & Comment, Image Upload.{' '}
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js, Node.js, Express.js, MongoDB, Multer.
                          </p>

                          <a
                            target='_blank'
                            href='https://dalle-clone-mike-rambil.vercel.app/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='portfolio-card' data-aos='fade-left'>
                      <div>
                        {' '}
                        <img
                          src='assets/japanese-store.png'
                          alt='japanese-store'
                        />
                        <div class='card-content'>
                          <h2>Food Store Website</h2>

                          <p>
                            A template website made only out of HTML and CSS.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Branding:-
                            </strong>{' '}
                            <br />
                            Focused on having a brand colors, have themes, and
                            styles to suit the business brand.
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            Html & CSS Only.
                          </p>

                          <a
                            target='_blank'
                            href='https://sushi-store-mike.vercel.app/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <div
                  className='p-panel'
                  id='p-two-panel'
                  style={{
                    display: activeTab === 'p-two' ? 'block' : 'none',
                  }}
                >
                  <section className='portfolio-section-grid'>
                    <div className='portfolio-card'>
                      <div>
                        {' '}
                        <img src='assets/natours.png' alt='' />
                        <div class='card-content'>
                          <h2>Natours (CRUD | Server Side Render)</h2>

                          <p>
                            A server-side hosted user-friendly website that
                            allows tourists to easily log in, plan their trips,
                            and receive helpful guidance for their routes from
                            tour guides.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Create Reviews, Post Reviews, Authentication,
                            Authorization, Stripe Payment, Server Side
                            Rendering.
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js, Redux Toolkit, Node.js, Express.js,
                            MongoDB, Multer, JWT Token.
                          </p>

                          <a
                            target='_blank'
                            href='https://natours-qnzb.onrender.com/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='portfolio-card'>
                      <div>
                        {' '}
                        <img src='assets/pro-admin-dashboard.png' alt='' />
                        <div class='card-content'>
                          <h2>Pro Admin Dashboard </h2>

                          <p>
                            Please Create an Account to access all features.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Dark and Light Mode, Charts, Input forms, Sidebar,
                            Navbar, Profile Management.
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js, Redux Toolkit.
                          </p>

                          <a
                            target='_blank'
                            href='https://admin-dashboard-mike-rambil.onrender.com/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='portfolio-card'>
                      <div>
                        {' '}
                        <img src='assets/blogmarine.png' alt='' />
                        <div class='card-content'>
                          <h2>Blog Marine (Full-Stack)</h2>

                          <p>
                            Please Create an Account to access all features.
                            This Project performs CRUD Operations.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Authentication, Authorization, Profile Management,
                            Image Upload, Friends Management, Edit Blog, Add
                            Styles, Re-edit Blog.
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js, Redux Toolkit, Node.js, Express.js,
                            MongoDB, Multer, JWT Token.
                          </p>

                          <a
                            target='_blank'
                            href='https://blogmarine-frontend.onrender.com/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='portfolio-card'>
                      <div>
                        {' '}
                        <img src='assets/gpt-2-clone.png' alt='' />
                        <div class='card-content'>
                          <h2>GPT-3 CLone (Front End Only)</h2>

                          <p>
                            A website that showcases information about GPT-3 and
                            OpenAI through a visually appealing and
                            user-friendly interface.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Highlights the potential applications and benefits
                            of GPT-3, while providing access to resources, case
                            studies, and the ability to sign up for early
                            access.
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js.
                          </p>

                          <a
                            target='_blank'
                            href='https://gpt-3-mockup-by-mike-rambil.vercel.app/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <div
                  className='p-panel'
                  id='p-three-panel'
                  style={{
                    display: activeTab === 'p-three' ? 'block' : 'none',
                  }}
                >
                  <section className='portfolio-section-grid'>
                    <div className='portfolio-card'>
                      <div>
                        {' '}
                        <img src='assets/movieland.png' alt='' />
                        <div class='card-content'>
                          <h2>Movieland (Search Bar Enabled) </h2>

                          <p>
                            An online movie database to search for your favorite
                            movies through the search bar.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Data fetching, View Movies, Filter, Search.
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js, Redux Toolkit, Node.js, Express.js.
                          </p>

                          <a
                            target='_blank'
                            href='https://movie-land-mike-rambil.vercel.app/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='portfolio-card'>
                      <div>
                        {' '}
                        <img src='assets/admin-dashboard.png' alt='' />
                        <div class='card-content'>
                          <h2>Admin Dashboard (Full Stack)</h2>

                          <p>
                            Please be patient for the backend to wake-up when
                            opening the front-end.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Dark and Light Mode, Chart Representation, Real-Time
                            Data Synchronization, Authorization, Profile
                            Management. <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            React.js, Redux Toolkit, Node.js, Express.js,
                            MongoDB, JWT Token.
                          </p>

                          <a
                            target='_blank'
                            href='https://ecomvision-frontend-wiqf.onrender.com/dashboard'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='portfolio-card'>
                      <div>
                        {' '}
                        <img src='assets/nodefarm.png' alt='' />
                        <div class='card-content'>
                          <h2>
                            Node Farm (First Ever Project | Server Side Render)
                          </h2>

                          <p>
                            Please be patient for the server to wake-up when
                            navigating to this project URL. My first ever basic
                            project built with just html and css.
                            <br />
                            <strong
                              style={{ color: 'blueviolet', fontWeight: '900' }}
                            >
                              Features:-
                            </strong>{' '}
                            <br />
                            Checkout each data information.
                            <br />
                            <strong
                              style={{ color: 'chocolate', fontWeight: '900' }}
                            >
                              Stack:-
                            </strong>{' '}
                            <br />
                            Html5, Css3, Nodejs, Expressjs, File System.
                          </p>

                          <a
                            target='_blank'
                            href='https://node-farm-v2hu.onrender.com/'
                            class='button gg-website'
                            rel='noreferrer'
                          >
                            <span
                              class='material-symbols-outlined'
                              style={{ display: 'block', width: '100px' }}
                            >
                              View WEBSITE
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <h2 className='portfolio-my-projects anime-grad' data-aos='flip-up'>
              My Projects
            </h2>
          </div>
          <div className='portfolio-copy' data-aos='fade-left'>
            <div>
              <h2
                className='auto-underline-animation portfolio-heading '
                data-aos='fade-up'
              >
                My
                <br /> Work
              </h2>
            </div>
            <div>
              <h2 className='portfolio-copy_text-right' data-aos='fade-up'>
                Deployed <span className='whitening-cream'>scalable </span>{' '}
                tourism event managment, job-seeker's platform full-stack web
                applications{' '}
                <span className='whitening-cream'>using the MERN-Stack. </span>{' '}
                I am also interested in data analytics and visualization.
              </h2>
              <h2 className='portfolio-copy_text-right'>
                <div className='portfolio-remarks'>
                  <div className='portfolio-remarks_content'>
                    <div
                      className='portfolio-remarks_contents whitening-cream hover-underline-animation'
                      data-aos='flip-up'
                      data-aos-delay='500'
                      data-aos-duration='500ms'
                    >
                      <img
                        width='35'
                        height='35'
                        src='assets/toolbox.svg'
                        alt='radio-button-emoji'
                      />
                      20+ Projects
                    </div>
                    <div
                      className='portfolio-remarks_contents whitening-cream hover-underline-animation'
                      data-aos='flip-up'
                      data-aos-delay='750'
                      data-aos-duration='700ms'
                    >
                      <img
                        width='35'
                        height='35'
                        src='assets/toolbox.svg'
                        alt='radio-button-emoji'
                      />
                      Industry-Standard Practices
                    </div>
                    <div
                      className='portfolio-remarks_contents whitening-cream hover-underline-animation'
                      data-aos='flip-up'
                      data-aos-delay='800'
                      data-aos-duration='760ms'
                    >
                      <img
                        width='35'
                        height='35'
                        src='assets/toolbox.svg'
                        alt='radio-button-emoji'
                      />
                      Commitment to continuos learning
                    </div>
                  </div>
                </div>
              </h2>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyPortfolio;
